<template>
    <div class="choice-type-import">
        <div class="list-card-import">
            <div v-if="isOneImportDirectoryEnabled" class="category">
                <span class="typographies-heading-h3 category__title">
                    {{ $l10n.__('Répertoire') }}
                </span>
                <div class="import-card-container">
                    <ImportCardType
                        v-if="getImportData('company').is_enabled"
                        :data="getImportData('company')"
                    />
                    <ImportCardType
                        v-if="getImportData('individual').is_enabled"
                        :data="getImportData('individual')"
                    />
                    <ImportCardType
                        v-if="getImportData('contact').is_enabled"
                        :data="getImportData('contact')"
                    />
                </div>
            </div>
            <div v-if="isOneImportCatalogEnabled" class="category">
                <span class="typographies-heading-h3 category__title">
                    {{ $l10n.__('Catalogue') }}
                </span>
                <div class="import-cards">
                    <div class="import-card-container">
                        <ImportCardType
                            v-if="getImportData('product').is_enabled"
                            :data="getImportData('product')"
                        />
                        <div class="sub-imports">
                            <ImportCardType
                                v-if="getImportData('product-variation').is_enabled"
                                :data="getImportData('product-variation')"
                                :isSubImport="true"
                            />
                            <ImportCardType
                                v-if="
                                    getImportData('product-price') &&
                                    getImportData('product-price').is_enabled
                                "
                                :data="getImportData('product-price')"
                                :isSubImport="true"
                            />
                        </div>
                    </div>
                    <div class="import-card-container">
                        <ImportCardType
                            v-if="getImportData('service').is_enabled"
                            :data="getImportData('service')"
                        />
                        <div class="sub-imports">
                            <ImportCardType
                                v-if="
                                    getImportData('service-price') &&
                                    getImportData('service-price').is_enabled
                                "
                                :data="getImportData('service-price')"
                                :isSubImport="true"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="isOtherImportEnabled" class="category">
                <span class="typographies-heading-h3 category__title">
                    {{ $l10n.__('Autres données') }}
                </span>
                <div class="import-card-container">
                    <ImportCardType
                        v-if="getImportData('comment').is_enabled"
                        :data="getImportData('comment')"
                    />
                    <ImportCardType
                        v-if="getImportData('stock').is_enabled"
                        :data="getImportData('stock')"
                    />
                    <ImportCardType
                        v-if="getImportData('opportunity').is_enabled"
                        :data="getImportData('opportunity')"
                    />
                </div>
            </div>
        </div>
        <div class="import-alert-wrapper">
            <CompassAlert
                :showIcon="true"
                :description="localizedText.alert"
                :action="actionAlert"
                class="import-choice-alert-info"
            />
        </div>
    </div>
</template>

<script>
import ImportCardType from 'vcomponents/settings/import/ImportCardType.vue';
import importsMixins from 'vcomponents/settings/import/importsMixins.js';
import { createNamespacedHelpers } from 'vuex';
const importsStore = createNamespacedHelpers('importsStore');

export default {
    components: {
        ImportCardType,
    },
    mixins: [importsMixins],
    data() {
        return {
            baseUrlImportV1: '',
            localizedText: {
                alert: this.$l10n.__(
                    'Si le type de données que vous souhaitez importer ne figure pas dans la liste, nos équipes peuvent vous aider.',
                ),
            },
            actionAlert: {
                label: this.$l10n.__('Contacter le support'),
                callback: () => window.MySupport.getForm(),
            },
        };
    },
    computed: {
        ...importsStore.mapGetters(['getMetadataImport']),
        isOneImportDirectoryEnabled() {
            return (
                this.getImportData('company').is_enabled ||
                this.getImportData('individual').is_enabled ||
                this.getImportData('contact').is_enabled
            );
        },
        isOneImportCatalogEnabled() {
            return (
                this.getImportData('product').is_enabled ||
                this.getImportData('product-variation').is_enabled ||
                this.getImportData('product-price')?.is_enabled ||
                this.getImportData('service').is_enabled ||
                this.getImportData('service-price')?.is_enabled
            );
        },
        isOtherImportEnabled() {
            return (
                this.getImportData('comment').is_enabled ||
                this.getImportData('stock').is_enabled ||
                this.getImportData('opportunity').is_enabled
            );
        },
    },
    created() {
        try {
            fetch('/?_f=import', {
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'POST',
                body: JSON.stringify({ action: 'checkAutoLoad' }),
            })
                .then((res) => res.json())
                .then(({ success }) => {
                    this.baseUrlImportV1 =
                        success.url +
                        '/index.php?autolog=Y&lang=' +
                        success.lang +
                        '&oauth_token=' +
                        success.token +
                        '&oauth_secret=' +
                        success.secret +
                        '&c=';
                });
        } catch {
            this.baseUrlImportV1 = '';
        }
        this.updateHasCustomFields(false);
    },
    methods: {
        ...importsStore.mapActions(['updateHasCustomFields', 'updateTypeImport']),
        getImportData(type) {
            return this.getMetadataImport.find((item) => item.type === type);
        },
    },
};
</script>

<style lang="scss" scoped>
.choice-type-import {
    .import-alert-wrapper {
        padding-bottom: var(--spacing-6);
    }

    .list-card-import {
        .category {
            border-bottom: solid 1px var(--colors-common-border-lighter);
            padding-bottom: var(--spacing-4);

            &__title {
                display: inline-block;
                margin-bottom: var(--spacing-1);
            }

            &:not(:first-child) {
                margin-top: var(--spacing-4);
            }

            &:last-child {
                margin-bottom: var(--spacing-4);
            }

            .import-cards {
                display: grid;
                gap: var(--spacing-3);
            }

            .import-card-container {
                display: grid;
                gap: var(--spacing-3);
                grid-template-columns: repeat(12, 1fr);

                .compass-tooltip {
                    grid-column: span 4;
                }
                :deep(.compass-tooltip__element) {
                    width: 100%;
                }

                .sub-imports {
                    display: grid;
                    gap: var(--spacing-3);
                    grid-column: span 8;
                    grid-template-columns: repeat(12, 1fr);

                    .compass-tooltip {
                        grid-column: span 4;
                    }
                }
            }
        }
    }
}
</style>
